import styled from 'styled-components';
import { PhotographyWrapper } from '../photography/PhotographyStyles';

export const LocationsWrapper = styled(PhotographyWrapper)`
  .coverage-hero { padding-bottom: 40px; }
  .coverage-hero h1 { max-width: 1050px; margin-left: auto; margin-right: auto; }
  .coverage-hero .photo-copy { max-width: 750px; }
  .coverage-hero .photo-actions { justify-content: center; }
  .coverage-map { max-width: 900px; margin: 24px auto 0; }
  .coverage-map svg.rsm-svg { display: block; width: 100%; height: auto; }
  .coverage-map-caption { text-align: center; font: 400 15px/1.6 'Nunito Sans',sans-serif; color: #52617e; margin: 12px auto 0; }
  .coverage-directory { scroll-margin-top: 24px; }
  .coverage-directory-header, .coverage-service-intro { display: grid; grid-template-columns: 1.25fr 1fr; gap: 56px; align-items: center; }
  .coverage-directory-header .photo-copy, .coverage-service-intro .photo-copy { margin-bottom: 0; }
  .coverage-search label { display: block; font: 600 16px/1.5 'Nunito Sans',sans-serif; margin-bottom: 10px; }
  .coverage-search input { width: 100%; box-sizing: border-box; padding: 15px 18px; border: 1px solid #cbd5e9; border-radius: 8px; background: white; color: #1b264f; font: 400 17px/1.5 'Nunito Sans',sans-serif; }
  .coverage-search input:focus-visible { outline: 3px solid #7c9aff; outline-offset: 3px; }
  .coverage-result-count { font: 400 16px/1.6 'Nunito Sans',sans-serif; color: #52617e; margin: 28px 0 20px; }
  .coverage-location-grid { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); gap: 24px; }
  .coverage-location { border: 1px solid #e4e8ef; border-radius: 14px; overflow: hidden; text-decoration: none; }
  .coverage-location:hover { box-shadow: 0 10px 26px #1b264f10; }
  .coverage-location img { display: block; width: 100%; height: 200px; object-fit: cover; }
  .coverage-location > div { padding: 22px; }
  .coverage-location p { font: 400 15px/1.5 'Nunito Sans',sans-serif; color: #52617e; margin: 0 0 6px; }
  .coverage-location span { font: 600 16px/1.5 'Nunito Sans',sans-serif; color: #2c5bff; }
  .coverage-help { display: flex; flex-wrap: wrap; align-items: center; gap: 24px; border-top: 1px solid #e4e8ef; padding-top: 28px; margin-top: 32px; }
  .coverage-help > div { flex: 1; min-width: 250px; }
  .coverage-help h3 { margin-bottom: 8px; }
  .coverage-help p { font: 400 17px/1.65 'Nunito Sans',sans-serif; color: #52617e; margin: 0; }
  .coverage-services-band { background: #f6f8fc; }
  .coverage-services { display: grid; grid-template-columns: repeat(3,minmax(0,1fr)); gap: 36px 40px; margin-top: 36px; }
  .coverage-service { text-decoration: none; border-top: 1px solid #cbd5e9; padding-top: 24px; }
  .coverage-service:hover h3 { color: #2c5bff; }
  .coverage-service-icon { display: inline-grid; place-items: center; width: 44px; height: 44px; background: #e8eeff; color: #2c5bff; border-radius: 10px; margin-bottom: 18px; }
  .coverage-service p { font: 400 17px/1.65 'Nunito Sans',sans-serif; color: #52617e; margin: 0 0 14px; }
  @media(max-width:991px) { .coverage-directory-header, .coverage-service-intro { gap: 32px; } .coverage-location-grid { grid-template-columns: repeat(2,minmax(0,1fr)); } }
  @media(max-width:767px) {
    .coverage-hero { padding-bottom: 28px; }
    .coverage-map { margin-top: 28px; }
    .coverage-map-caption { font-size: 14px; }
    .coverage-directory-header, .coverage-service-intro { grid-template-columns: 1fr; gap: 24px; }
    .coverage-location-grid { gap: 12px; }
    .coverage-location img { height: 130px; }
    .coverage-location > div { padding: 16px 12px; }
    .coverage-location h3 { font-size: 17px; }
    .coverage-location span { font-size: 14px; }
    .coverage-help { gap: 20px; }
    .coverage-help > div { flex-basis: 100%; }
    .coverage-services { grid-template-columns: repeat(2,minmax(0,1fr)); gap: 24px 16px; margin-top: 28px; }
    .coverage-service h3 { font-size: 17px; }
    .coverage-service p, .coverage-service .photo-link { font-size: 15px; }
  }
`;export const BlueText = styled.span`color: #506BCA;`;
